const UserMessageFilter = (messages, filters) => {
    if (!filters || !messages) return messages;

    return messages.filter(item => {
        return Object.entries(filters).every(([key, filter]) => {
            if (!filter) return true;

            if (key === "dtIni" || key === "dtEnd") {
                const date = new Date(item.createdAt);
                if (filters.dtIni && !filters.dtEnd) return date >= filters.dtIni;

                if (!filters.dtIni && filters.dtEnd) return date <= filters.dtEnd;

                if (filters.dtIni && filters.dtEnd) return date >= filters.dtIni && date <= filters.dtEnd;
            }

            if (key === "status") {
                if (filter === "all") return true;
                else return item.status === filter;
            }

            if (filter === "all") return true;

            if (item[key] === undefined) return true;

            return item[key].toString() === filter;
        });
    });
};

export default UserMessageFilter;